/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import InViewComponent from '../../../shared/components/inView/inView';


/**
 * InnerBanner components is used to render component Inner Banner
 * @param {*} props 
 */
const InnerBanner = ({ banner_cta_button, banner_image, banner_info, banner_title }) => {
    const [inViewBanner, setInViewBanner] = useState(false);
    useEffect(() => {
        handleAnimation();
    }, [inViewBanner]);

    /**
     * handleAnimation method is used to animate div according to left and right
     * when component is in view
     */
    const handleAnimation = () => {
        const textHeading = document.getElementsByClassName("slide-left")[0];
        const svgIllustrated = document.getElementsByClassName("slide-right")[0];
        if (textHeading && svgIllustrated) {
            if (inViewBanner) {
                textHeading.classList.add("is-animate");
                svgIllustrated.classList.add("is-animate");
            } else {
                textHeading.classList.remove("is-animate");
                svgIllustrated.classList.remove("is-animate");
            }
        }
    };
    return (
        <InViewComponent setInview={ (value) => {
            setInViewBanner(value);
        } }>
            <div className="innerBaneer">
                <div className="container">
                    <div className="row-wrap">
                        <div className="box-12 box-md-6 img-box">
                            <div className="customAnim slide-right">
                                <div className="inner-box">
                                    {
                                        banner_image &&
                                        <figure>
                                            <img src={ banner_image.url } alt="animated" />
                                        </figure>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="box-12 box-md-6 content-box">
                            <div className="customAnim slide-left">
                                <div className="inner-box">
                                    <div className="intro-box p-18">
                                        {
                                            banner_title &&
                                            <h1 className="heading has-line">{ banner_title }</h1>
                                        }
                                        {
                                            banner_info &&
                                            <p dangerouslySetInnerHTML={ { __html: banner_info } } />
                                        }
                                        {
                                            banner_cta_button &&
                                            <div className="button-box">
                                                <a href={ banner_cta_button.url } target={ banner_cta_button.target !== "" ? "_blank" : "_self" } className="button button-outline big-size">{ banner_cta_button.title }</a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ InViewComponent>
    );
};


export default InnerBanner;